import {PartsHttp} from "../../../http/parts";

export default {
    async setParts({commit}) {
        const parts = await PartsHttp.getAllParts();
        commit('setParts', parts);
    },
    setActivePart({commit}, part) {
        commit('setActivePart', part);
    },
    setManagePartDialog({commit}, status) {
        commit('setManagePartDialog', status);
    },
    setManageDeletePartDialog({commit}, status) {
        commit('setManageDeletePartDialog', status);
    }
}
